const negator = {
  match: '!',
}

export default negator
